import { nodesToArray } from "@pod-point/dom-ops";
import { Delegate } from "dom-delegate";
import { init, trackEvent } from "./helpers";

let instances = [];
const EVENTS = {
    CTA_CLICK: "cta_click",
    NAV_CLICK: "nav_click",
    PAGE_VIEW: "page_view",
};

class TrackEvent {
    constructor(element) {
        init(window.gtmId);

        // Page view tracking
        trackEvent(EVENTS.PAGE_VIEW, {
            page_type: window.location.pathname,
        });

        this.triggers = nodesToArray(element.querySelectorAll("[data-track-event-name]")) || [];
        this.bindEvents();
    }

    /**
     * Track element click event.
     *
     * @return {void}
     */
    bindTrackClickEvent(triggerListener) {
        triggerListener.on("click", (_event, clickedElement) => {
            const eventName = clickedElement.dataset.trackEventName || null;

            if (eventName !== null) {
                const properties = Object.entries(clickedElement.dataset)
                    .filter(([key]) => key.includes("trackData"))
                    .reduce((acc, [key, value]) => {
                        const propertyKey = key.replace("trackData", "").toLowerCase();

                        return { ...acc, [propertyKey]: value };
                    }, {});

                trackEvent(eventName, properties);
            }
        });
    }

    EVENT_TRIGGERS = {
        [EVENTS.CTA_CLICK]: this.bindTrackClickEvent,
        [EVENTS.NAV_CLICK]: this.bindTrackClickEvent,
    };

    /**
     * Bind tracking events.
     *
     * @return {void}
     */
    bindEvents() {
        this.triggers.forEach((trigger) => {
            const triggerListener = new Delegate(trigger);
            const bindTriggerMethod = this.EVENT_TRIGGERS[trigger.dataset.trackEventName];
            if (bindTriggerMethod) {
                bindTriggerMethod(triggerListener);
            }
        });
    }
}

export default {
    init: (element) => {
        instances.push(new TrackEvent(element));
    },

    destroy: () => {
        instances = [];
    },
};

export { TrackEvent, EVENTS };
